import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { Textarea } from "../components/ui/textarea";
import { api, errMsg } from "../lib/api";
import { RatingForm } from "../components/app/EvaluationCards";
import { TauMark, LangSwitch } from "../components/app/Layout";

const deviceId = () => {
  let id = localStorage.getItem("mpi_device");
  if (!id) { id = crypto.randomUUID(); localStorage.setItem("mpi_device", id); }
  return id;
};

export default function RateQR() {
  const { token } = useParams();
  const [p, setP] = useState(null);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [f, setF] = useState({ usefulness: 0, accessibility: 0, needs_more_help: null, comment: "" });
  useEffect(() => { api.get(`/public/rate/${token}`).then((r) => setP(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);
  const send = async () => {
    try { await api.post(`/public/rate/${token}`, { ...f, device_id: deviceId() }); setDone(true); } catch (e) { setErr(errMsg(e)); }
  };
  return (
    <div className="min-h-screen bg-[#FAFAF7] paper-grain px-5 py-8">
      <div className="mx-auto max-w-lg">
        <div className="flex items-center justify-between text-amber-900"><span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest"><TauMark className="h-6 w-6" />St. Francis of Assisi Parish</span><LangSwitch /></div>
        {err && <p className="mt-10 rounded-lg bg-white p-5 text-sm text-stone-700" data-testid="rate-error">{err}</p>}
        {p && !done && (
          <div className="mt-8 space-y-5 rounded-xl border border-amber-700/15 bg-white p-6" data-testid="rate-form">
            <div>
              <p className="text-xs uppercase tracking-widest font-semibold text-amber-800/80">Program feedback · {p.gkk_name}</p>
              <h1 className="mt-1 font-serif-display text-3xl font-bold text-amber-950" data-testid="rate-program-title">{p.intervention}</h1>
              <p className="mt-2 text-sm text-stone-600">Voluntary and anonymous. No sign-in, no names. Thank you for helping the parish serve better.</p>
            </div>
            <RatingForm value={f} onChange={setF} />
            <Textarea rows={3} maxLength={500} placeholder="Optional comment (please do not write names or private details)" value={f.comment} onChange={(e) => setF({ ...f, comment: e.target.value })} data-testid="rate-comment-input" />
            <Button disabled={!f.usefulness || !f.accessibility} onClick={send} className="w-full bg-amber-900 hover:bg-[#5B210B]" data-testid="rate-submit-button">Send feedback</Button>
          </div>
        )}
        {done && (
          <div className="mt-10 rounded-xl bg-white p-8 text-center" data-testid="rate-thanks">
            <CheckCircle2 className="mx-auto h-10 w-10 text-[#285E3B]" />
            <p className="mt-3 font-serif-display text-3xl font-bold text-amber-950">Salamat! Thank you!</p>
            <p className="mt-2 text-sm text-stone-600">Your feedback was received. Peace and all good.</p>
          </div>
        )}
      </div>
    </div>
  );
}
